<script lang="ts">
    import { RuleEngine } from "../RuleEngine"
    import inputfields from "./"

    let {
        ftpAssetsUrl,
        currentChoices = null,
        value = $bindable(),
        dependsOn,
        label,
        subFields = [],
        values = $bindable(),
        onInvalidConfig,
    }: FieldComponentProps = $props()
    if (!value) value = {}
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $derived(values && dependsOn ? ruleEngine.resolve(dependsOn, values) : true)
</script>

{#if displayComponent}
    <div class="object">
        {#if label}
            <label for="">{label}</label>
        {/if}
        {#each subFields || [] as field}
            {@const SvelteComponent =
                inputfields[(field.widget as keyof typeof inputfields) || (field.type as keyof typeof inputfields)] ||
                inputfields.default}

            <SvelteComponent
                {...field}
                {values}
                bind:value={value[field.name]}
                {currentChoices}
                {onInvalidConfig}
                {ftpAssetsUrl}
            />
        {/each}
    </div>
{/if}
